import { skipToken } from '@reduxjs/toolkit/query';
import { useGetVehicleId } from 'pages/CreateVehicle/hooks/useGetVehicleId';
import { useGetSectionsQuery } from 'services/api/vehicle-sections';

export const useExteriorSectionData = (sectionName: string, raw?: boolean) => {
  const vehicleId = useGetVehicleId();
  const { data: sections } = useGetSectionsQuery(vehicleId || skipToken);

  const section = sections?.exterior?.subsections?.[sectionName];
  const subSections = section?.subsections || {};
  const images = section?.images || [];
  if (raw) {
    return { subSections, images };
  }
  return { subSections, images: images.filter(img => !!img?.url) };
};
